import React, { useState } from 'react'
import { Box, CircularProgress, IconButton, Typography } from '@mui/material'
import { GRAY_COLORS } from 'asterX-UI'
import { BlueLines } from 'asterX-UI/Icons/BlueLines'
import { DownloadIcon } from 'asterX-UI/Icons/DownloadIcon'
import { FileIcon } from 'asterX-UI/Icons/FileIcon'
import ActionModal from 'asterX-UI/Modals/ActionModal'
import { useContractStore } from 'context/ContractStore'
import { CreditFlow } from 'lib/api/services/creditFlow.service'

const GaranteeFileModal = ({ openModal, closeModal = () => {} }) => {
  const {
    contractStore: { GaranteeFile }
  } = useContractStore()

  const [docLoading, setDocLoading] = useState(false)

  const files = GaranteeFile ? [{ ...GaranteeFile, name: 'Гарантийное письмо' }] : []

  const openDocument = async fileID => {
    try {
      setDocLoading(true)
      const response = await CreditFlow.getTempFilesByField(fileID)
      const blob = new Blob([response.data], { type: 'application/pdf' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'Гарантийное письмо' // important!
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      setTimeout(() => URL.revokeObjectURL(url), 100) // revoke after short delay (safer)
    } catch (error) {
      console.error(error)
    } finally {
      setDocLoading(false)
    }
  }

  console.log(GaranteeFile)

  return (
    <ActionModal open={!!openModal} onClose={closeModal} title="Гарантийное письмо" maxWidth="md">
      <Box display="flex" flexDirection="column" gap="10px">
        {files.length > 0 ? (
          files.map((item, idx) => (
            <Box
              key={idx}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: 3,
                borderRadius: '8px',
                border: `1px solid ${GRAY_COLORS[200]}`,
                width: '100%',
                mb: 2
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box sx={{ position: 'relative' }}>
                  <FileIcon />
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)'
                    }}
                  >
                    <BlueLines />
                  </Box>
                </Box>
                <Typography sx={{ fontSize: 14, fontWeight: 500, wordBreak: 'break-word' }}>{item.name}</Typography>
              </Box>

              {docLoading ? (
                <CircularProgress />
              ) : (
                <IconButton onClick={() => openDocument(item.fileId)} sx={{ p: 1 }}>
                  <DownloadIcon sx={{ color: GRAY_COLORS[600] }} />
                </IconButton>
              )}
            </Box>
          ))
        ) : (
          <Box display="flex" flexDirection="column" alignItems="center" gap="15px">
            <CircularProgress />
            <Typography sx={{ fontSize: 14, fontWeight: 500 }}>Загрузка файла...</Typography>
          </Box>
        )}
      </Box>
    </ActionModal>
  )
}

export default GaranteeFileModal
